import { render } from "./writein-input.vue?vue&type=template&id=f5ca9c84"
import script from "./writein-input.vue?vue&type=script&lang=js"
export * from "./writein-input.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__